import makeStyles from "@material-ui/core/styles/makeStyles";

import reactChildrenType from "common/proptypes/react-children.proptypes";
import { SidebarContainer } from "common/layout/sidebar/sidebar.container";
import Header from "./header/header.container";
import layoutStyles from "./layout.styles";

const useStyles = makeStyles(layoutStyles);

function Layout({ children }) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <SidebarContainer className={classes.sidebar} />
      <section className={classes.content}>
        <Header className={classes.header} />
        <main className={classes.main}>{children}</main>
      </section>
    </div>
  );
}

Layout.propTypes = {
  children: reactChildrenType.isRequired,
};

export default Layout;
